export default __webpack_public_path__ + "static/media/correct-ico.d54282cb.webp";